import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, Observable, Subject, throwError } from 'rxjs';

import {
  DOCUMENTS_REPOSITORY,
  DocumentsRepository
} from '@app/domain/repositories/ptrab/documents/documents.repository.contract';
import { ErrorMsgEnum } from '@app/entities/enums/error/error-msg-enum';
import { ErrorCodes } from '@app/entities/models/error/error.model';
import { DocumentUrl } from '@app/entities/models/ptrab/documents/document-url.model';
import { Document } from '@app/entities/models/ptrab/documents/document.model';

import { DocumentsUseCases } from './documents.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class DocumentsUseCasesImpl implements DocumentsUseCases {
  #errorSubject: Subject<ErrorMsgEnum> = new Subject<ErrorMsgEnum>();
  error$ = this.#errorSubject.asObservable();
  #documentsRepository: DocumentsRepository = inject(DOCUMENTS_REPOSITORY);

  getDocuments(): Observable<Document[]> {
    return this.#documentsRepository.getDocuments().pipe(catchError(this.handleError));
  }

  getDocumentUrlById(documentId: string): Observable<DocumentUrl> {
    return this.#documentsRepository.getDocumentUrlById(documentId).pipe(catchError(this.handleError));
  }

  getOnBoardingDocumentUrlById(documentId: string): Observable<DocumentUrl> {
    return this.#documentsRepository.getOnBoardingDocumentUrlById(documentId).pipe(catchError(this.handleError));
  }
  getOnBoardingDocument(): Observable<Document[]> {
    return this.#documentsRepository.getOnBoardingDocument().pipe(catchError(this.handleError));
  }

  private handleError = (error: HttpErrorResponse): Observable<never> => {
    let errorType;

    switch (error.status) {
      case ErrorCodes.LOCKED:
        errorType = ErrorMsgEnum.SERVICE_LOCKED;
        break;
      case ErrorCodes.SECTION_MAINTENANCE:
        errorType = ErrorMsgEnum.SECTION_MAINTENANCE;
        break;
      default:
        errorType = ErrorMsgEnum.SERVER_ERROR;
        break;
    }

    this.#errorSubject.next(errorType);

    return throwError(() => error);
  };
}
